import React, { useEffect, useState } from "react";

import { useApp } from "../../contexts/AppContext";

import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import CreateParty from "./CreateParty";
import JoinParty from "./JoinParty";

function CreateOrJoinParty() {
  const {
    state: { event, globalUser },
    setBlurBackground,
  } = useApp();

  const [showCreate, setShowCreate] = useState(false);
  const [showJoin, setShowJoin] = useState(false);

  useEffect(() => {
    setBlurBackground(true);
  }, [setBlurBackground]);

  if (!event || !globalUser) return null;

  return (
    <>
      <div className="flex flex-1 flex-col">
        <div className="flex-1 flex flex-col justify-center items-center relative">
          <div className="text-center">
            <p className="mb-4 px-2 text-4xl text-center">
              Hi {globalUser.nickName}!
            </p>
            <p className="mb-8 text-2xl text-center">
              Create a party and invite
              <br />
              your friends and family
              <br />
              to join!
            </p>
            <Button
              onClick={() => setShowCreate(true)}
              variant="primary"
              size="xl"
              className="shadow-xl"
            >
              Create party
            </Button>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center items-center relative">
          <div className="text-center">
            <p className="mb-4 px-2 text-4xl text-center">
              Invited to
              <br />
              someones party?
            </p>

            <p className="mb-8 text-2xl text-center">Enter the party ID<br />and join them!</p>

            <Button
              onClick={() => setShowJoin(true)}
              variant="primary"
              size="xl"
              className="shadow-xl"
            >
              Join party
            </Button>
          </div>
        </div>
      </div>
      {showCreate && (
        <Modal title="Create party" onClose={() => setShowCreate(false)}>
          <CreateParty onCancel={() => setShowCreate(false)} />
        </Modal>
      )}
      {showJoin && (
        <Modal title="Join party" onClose={() => setShowJoin(false)}>
          <JoinParty />
        </Modal>
      )}
    </>
  );
}

export default CreateOrJoinParty;
